import React from "react";
import { MuiChipsInput } from "mui-chips-input";
import { r } from "react-router/dist/development/fog-of-war-D4x86-Xc";

type ChipValidationProps = {
  value: string;
  onChange: (newChipsString: string) => void;
};

const getInitialChips = (value: string): string[] => {
  Array.isArray(value)
  if (Array.isArray(value)) {
    return value;
  }
  try {
    const parsedValue = JSON.parse(value);
    if (Array.isArray(parsedValue)) {
      return parsedValue;
    }
  } catch (e) {
    if (value && value.length > 0) {
      return [value];
    }
    return [];
  }
  return [];
};

const ChipValidation = ({ value, onChange }: ChipValidationProps) => {
  const [chips, setChips] = React.useState<string[]>(getInitialChips(value));

  const handleChange = (newChips: string[]) => {
    setChips(newChips);
    onChange(JSON.stringify(newChips));
  };

  return <MuiChipsInput value={chips} onChange={handleChange} />;
};

export default ChipValidation;
